import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchActiveEvent, fetchEvent, fetchEventLeaderboard, fetchEventStats } from '../../api/eventsApi';
import EventLeaderboard from './EventLeaderboard';
import EventStatsWidget from './EventStatsWidget';

export function EventChallengePage() {
  const { eventIdentifier = '' } = useParams();
  const [event, setEvent] = useState(null);
  const [stats, setStats] = useState(null);
  const [leaderboard, setLeaderboard] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    setError('');

    const initialRequest = eventIdentifier ? fetchEvent(eventIdentifier) : fetchActiveEvent();

    initialRequest
      .then(async (payload) => {
        if (cancelled) return;

        const activeEvent = payload?.event || null;
        setEvent(activeEvent);
        setStats(payload?.stats || null);
        setLeaderboard(Array.isArray(payload?.leaderboard) ? payload.leaderboard : []);

        if (activeEvent?.id) {
          const [statsPayload, leaderboardPayload] = await Promise.all([
            fetchEventStats(activeEvent.id).catch(() => null),
            fetchEventLeaderboard(activeEvent.id, { limit: 50 }).catch(() => null),
          ]);

          if (cancelled) return;
          setStats(statsPayload?.stats || payload?.stats || null);
          setLeaderboard(
            Array.isArray(leaderboardPayload?.leaderboard)
              ? leaderboardPayload.leaderboard
              : Array.isArray(payload?.leaderboard)
                ? payload.leaderboard
                : []
          );
        }
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err?.message || 'Challenge konnte nicht geladen werden.');
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [eventIdentifier]);

  if (loading) {
    return <main className="pfp-event-page"><div className="pfp-event-empty">Challenge wird geladen ...</div></main>;
  }

  if (error) {
    return <main className="pfp-event-page"><div className="pfp-event-empty is-error">{error}</div></main>;
  }

  if (!event) {
    return (
      <main className="pfp-event-page">
        <div className="pfp-event-empty">
          Gerade ist keine aktive Challenge eingetragen.
        </div>
      </main>
    );
  }

  return (
    <main className="pfp-event-page">
      <section className="pfp-event-page__hero">
        <span className="pfp-event-kicker">Event-Challenge</span>
        <h1>{event.title}</h1>
        {event.description ? <p>{event.description}</p> : null}
        <div className="pfp-event-banner__actions">
          <a className="pfp-event-button" href="#/quick-mark">Meldung erstellen</a>
          <a className="pfp-event-button pfp-event-button--secondary" href="#/map">Offene Quests ansehen</a>
        </div>
      </section>

      <EventStatsWidget stats={stats} />

      <section className="pfp-event-page__section">
        <h2>Rangliste</h2>
        <EventLeaderboard rows={leaderboard} />
      </section>
    </main>
  );
}

export default EventChallengePage;
